export const language = {
  zh: {
    'Your cart is still empty, so hurry up and buy goods!': '您的购物车还是空的，赶快行动起来，选购商品吧！',
    'Home': '商城首页',
    'Collect List': '收藏清单',
    'Cart': '购物车',
    'Select All': '全选',
    'Clear All': '清空购物车',
    'On Lining': '该功能即将上线',
    'Supplier ': '供应商',
    'Shipping Country': '发货国家',
    'Spec': '规格',
    'VAT': '增值税',
    'Import Tariffs': '进口关税',
    'Delete': '删除',
    'Move in Collect': '移入收藏清单',
    'MOQ': '起订量',
    'List Off': '已下架',
    'Invalid': '已失效',
    'lost': '已丢失',
    'Total': '总金额',
    'Product': '件商品',
    'Check Out': '进入结算中心',
    'New Products': '新品推荐',
    'Add to Cart': '加入购物车',
    'Exceed Purchase Volume!': '“超过最大可购买量！”',
    'Exceed Sell Stock': '“超过销售库存！”',
    'unit price': '未税单价',
    'Unit Price': '单价',
    'Without Tax': '未税',
    'With Tax': '含税',
    'Subtotal': '小计',
    'Total_': '已选择',
    '_N': '种',
    'N_': '件',
    '_Products': '商品',
    'Domestic': '国内',
    'International': '国际',
    'Ships From': '发货国家',
    'Remark': '备注',
    'Payment method': '支付方式',
    'Offline payment': '线下支付',
    'Leave Remark to the supplier': '给商家留言',
    'Fee': '费用',
    'When you choose our goods and services, you accept GSP Conditions of Use and Privacy Statement, which apply to all purchases you make at GSP.': '当您选择了我们的商品和服务，即表示您已经接受了采购平台的使用条件和隐私声明，适用于您在采购平台商店购买的全部商品。',
    'Total Amount': '总价',
    'Total1': '总价',
    'Place Order': '提交采购单',
    'Your order has been submitted successfully': '您的订单已提交成功',
    'Check out my purchase order': '查看我的采购单',
    'Total amount of goods': '商品总计',
  },
  en: {
    'Your cart is still empty, so hurry up and buy goods!': 'Your cart is still empty, so hurry up and buy goods!',
    'Home': 'Home',
    'Collect List': 'Collect List',
    'Cart': 'Cart',
    'Select All': 'Select All',
    'Clear All': 'Clear All',
    'On Lining': 'On Lining',
    'Supplier ': 'Supplier ',
    'Shipping Country': 'Shipping Country',
    'Spec': 'Spec',
    'VAT': 'VAT',
    'Import Tariffs': 'Import Tariffs',
    'Delete': 'Delete',
    'Move in Collect': 'Move in Collect',
    'MOQ': 'MOQ',
    'List Off': 'List Off',
    'Invalid': 'Invalid',
    'lost': 'lost',
    'Total': 'Total',
    'Product': 'Product',
    'Check Out': 'Check Out',
    'New Products': 'New Products',
    'Add to Cart': 'Add to Cart',
    'Exceed Purchase Volume!': 'Exceed Purchase Volume!',
    'Exceed Sell Stock': 'Exceed Sell Stock',
    'unit price': 'Unit price',
    'Unit Price': 'Unit Price',
    'Without Tax': 'Without Tax',
    'With Tax': 'With Tax',
    'Subtotal': 'Subtotal',
    'Total_': 'Total',
    '_N': '',
    'N_': '',
    '_Products': 'Products',
    'Domestic': 'Domestic',
    'International': 'International',
    'Ships From': 'Ships From',
    'Payment method': 'Payment method',
    'Offline payment': 'Offline payment',
    'Leave Remark to the supplier': 'Leave Remark to the supplier',
    'Fee': 'Fee',
    'When you choose our goods and services, you accept GSP Conditions of Use and Privacy Statement, which apply to all purchases you make at GSP.': 'When you choose our goods and services, you accept GSP Conditions of Use and Privacy Statement, which apply to all purchases you make at GSP.',
    'Total Amount': 'Total Amount',
    'Total1': 'Total',
    'Place Order': 'Place Order',
    'Your order has been submitted successfully': 'Your order has been submitted successfully',
    'Check out my purchase order': 'Check out my purchase order',
    'Total amount of goods': 'Total amount of goods',
  }
};
